import { 
  USER_SIGNED_OUT, 
  STORE_USER_ERROR, 
  USER_EXPIRED, 
  STORE_USER, 
  LOADING_USER,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT
} from '../../actions/types';
  
  const initialState = {
    user: null,
    isLoadingUser: false,
    authProvider: null,
    isAuthenticated: false,
    error: null
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case STORE_USER:
        return {
          ...state,
          isLoadingUser: false,
          user: action.payload,
          isAuthenticated: true
        }
      case LOADING_USER:
        return {
          ...state,
          isLoadingUser: true
        }
      case LOGIN_SUCCESS: {
        // Accept both { user, provider } and legacy user-only payloads
        const user = action.payload.user || action.payload;
        const provider = action.payload.provider || null;
        return {
          ...state,
          isLoadingUser: false,
          user,
          authProvider: provider,
          isAuthenticated: true,
          error: null
        }
      }
      case LOGIN_FAILURE:
        return {
          ...state,
          isLoadingUser: false,
          error: action.payload,
          isAuthenticated: false
        }
      case USER_EXPIRED:
      case STORE_USER_ERROR:
      case USER_SIGNED_OUT:
      case LOGOUT:
        return {
          ...state,
          user: null,
          isLoadingUser: false,
          authProvider: null,
          isAuthenticated: false
        }
      default:
        return state
    }
  }